import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/app/providers/AuthContext';
import { LoadingSpinner } from '@/ui/LoadingSpinner';
import { PageLayout, PageContent } from '@/components/PageLayout';

const AuthCallback: React.FC = () => {
  const { refreshSession } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const processCallback = async () => {
      await refreshSession();
      navigate('/dashboard');
    };
    processCallback();
  }, [refreshSession, navigate]);

  return (
    <PageLayout>
      <PageContent className="flex flex-col items-center justify-center text-center">
        <LoadingSpinner />
        <p className="text-muted-foreground mt-4">
          Finalizing authentication, please wait...
        </p>
      </PageContent>
    </PageLayout>
  );
};

export default AuthCallback;
